import { jsx as e, jsxs as l } from "react/jsx-runtime";
import i from "next/link.js";
import s from "./Avatar.js";
import m from "./Flag.js";
import n from "./formatDate.js";
import { H as o } from "./chunks/index-UjijAVoZ.js";
import { I as d } from "./chunks/index-CgDhSQ6a.js";
const b = ({ article: a, href: t }) => /* @__PURE__ */ e("div", { className: "px-5", children: /* @__PURE__ */ l(
  "div",
  {
    className: "container-xl flex flex-col gap-4 items-center py-5 tablet:flex-row tablet:gap-8 tablet:py-8",
    width: "xwide",
    children: [
      /* @__PURE__ */ e("div", { className: "rounded-xl relative min-h-[16rem] overflow-hidden w-full tablet:min-h-[20rem] tablet:w-1/2", children: /* @__PURE__ */ e(
        d,
        {
          alt: a.heroImage.alt || "",
          className: "object-cover",
          fill: !0,
          priority: !0,
          src: a.heroImage.url
        }
      ) }),
      /* @__PURE__ */ l("div", { className: "flex flex-col items-start gap-4 tablet:basis-1/2", children: [
        a.categories.length > 0 && /* @__PURE__ */ e("div", { className: "flex flex-wrap gap-3", children: a.categories.map((r) => /* @__PURE__ */ e(m, { className: "bg-blue-100 text-blue-500", children: r.name }, r.id)) }),
        /* @__PURE__ */ e(i, { href: t, children: /* @__PURE__ */ e(
          o,
          {
            className: "text-blue-500 hover:underline",
            level: "3",
            tagName: "h2",
            children: a.title
          }
        ) }),
        /* @__PURE__ */ e("p", { children: a.description }),
        /* @__PURE__ */ l("div", { className: "flex flex-wrap items-center gap-x-3 gap-y-2 font-semibold text-sm", children: [
          /* @__PURE__ */ e(s, { image: a.user.avatar, size: "sm" }),
          /* @__PURE__ */ e("span", { children: a.user.name }),
          /* @__PURE__ */ e("span", { children: "·" }),
          /* @__PURE__ */ e("span", { children: n(a.publishedAt) })
        ] })
      ] })
    ]
  }
) });
export {
  b as default
};
